function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHobbiesAndCollectibles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.817,8.651C15.817,7.945 15.372,7.324 14.805,6.902C13.915,6.235 13.363,5.314 13.363,4.294C13.363,2.262 15.564,0.613 18.271,0.613C20.979,0.613 23.18,2.262 23.18,4.294C23.18,5.314 22.628,6.235 21.738,6.902C21.17,7.324 20.726,7.945 20.726,8.651C20.726,9.632 21.523,10.43 22.505,10.43L26.861,10.43C28.894,10.43 30.543,12.079 30.543,14.111L30.543,18.468C30.543,19.449 31.34,20.247 32.322,20.247C33.028,20.247 33.649,19.802 34.071,19.235C34.738,18.345 35.658,17.793 36.678,17.793C38.711,17.793 40.36,19.994 40.36,22.701C40.36,25.409 38.711,27.61 36.678,27.61C35.658,27.61 34.738,27.058 34.071,26.168C33.649,25.601 33.028,25.156 32.322,25.156C31.34,25.156 30.543,25.953 30.543,26.935L30.543,36.2C30.543,38.232 28.894,39.881 26.861,39.881L22.505,39.881C21.523,39.881 20.726,39.084 20.726,38.102C20.726,37.396 21.17,36.775 21.738,36.353C22.628,35.686 23.18,34.766 23.18,33.746C23.18,31.713 20.979,30.064 18.271,30.064C15.564,30.064 13.363,31.713 13.363,33.746C13.363,34.766 13.915,35.686 14.805,36.353C15.372,36.775 15.817,37.396 15.817,38.102C15.817,39.084 15.019,39.881 14.038,39.881L4.773,39.881C2.74,39.881 1.091,38.232 1.091,36.2L1.091,26.935C1.091,25.953 1.889,25.156 2.871,25.156C3.576,25.156 4.198,25.601 4.619,26.168C5.287,27.058 6.207,27.61 7.227,27.61C9.26,27.61 10.909,25.409 10.909,22.701C10.909,19.994 9.26,17.793 7.227,17.793C6.207,17.793 5.287,18.345 4.619,19.235C4.198,19.802 3.576,20.247 2.871,20.247C1.889,20.247 1.091,19.449 1.091,18.468L1.091,14.111C1.091,12.079 2.74,10.43 4.773,10.43L14.038,10.43C15.019,10.43 15.817,9.632 15.817,8.651Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHobbiesAndCollectibles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hobbies-and-collectibles.f9a12e7fad228e00e9316e2fe5480603.svg";